import React from "react";
import { useMutation } from "@apollo/react-hooks";
import { bool, func, number, string } from "prop-types";

import GlobalState from "src/shared/utilities/globalState";

import getCurrentUser from "../../../authentication/src/helpers/getCurrentUser";
import { HIDE_LISTING_MUTATION, UNHIDE_LISTING_MUTATION } from "./mutations";
import * as S from "./styled";

const HideUnhideButton = props => {
  const [hideListing] = useMutation(HIDE_LISTING_MUTATION);
  const [unhideListing] = useMutation(UNHIDE_LISTING_MUTATION);
  const { property_id, property_type } = props;
  const options = { variables: { input: { property_id, property_type } } };

  const hide = withReload => {
    hideListing(options)
      .then(() => {
        props.setHidden(true);
        if (withReload) window.location.reload();
      })
      .catch(errors => console.log("errors", errors));
  };

  const unhide = () => {
    unhideListing(options)
      .then(() => props.setHidden(false))
      .catch(errors => console.log("errors", errors));
  };

  const isUserLoggedIn = async callback => {
    const viewerInfo = await getCurrentUser();

    return callback(!!viewerInfo);
  };

  const onHideClick = () => {
    isUserLoggedIn(loggedIn => {
      if (loggedIn) {
        hide(false);
      } else {
        const triggerScenario = GlobalState.get("triggerScenario");
        if (typeof triggerScenario === "function") {
          GlobalState.get("callbacks").accountCreated = undefined;
          GlobalState.get("callbacks").login = undefined;

          GlobalState.registerCallback("accountCreated", () => hide(true));
          GlobalState.registerCallback("login", () => hide(true));

          triggerScenario("");
        }
      }
    });
  };

  return props.isHidden ? (
    <S.LinkButton onClick={unhide}>Unhide</S.LinkButton>
  ) : (
    <S.LinkButton onClick={onHideClick}>
      Hide listing from search results
    </S.LinkButton>
  );
};

HideUnhideButton.propTypes = {
  property_id: number.isRequired,
  property_type: string.isRequired,
  isHidden: bool.isRequired,
  setHidden: func.isRequired
};

export default HideUnhideButton;
